import { asDateTime, Button, colors, Link, Tile, TileField } from 'lqx-react';
import * as React from 'react';
import { CommunicationModel } from '../../../../api/communication';

export const CommunicationTile = ({ data, style, index }) => {
    const communication : CommunicationModel = data.items[ index ];
    const $checked = data.selected.$includes( communication );

    return (
        <Tile
            $checked={ $checked }
            style={ style }

            color={ communication.read ? colors.grey : colors.green }
            leftTitle={ asDateTime(communication.createdOn) }
            left={
                <TileField>
                    { null }
                </TileField>
            }
            title={ communication.subject }
            extra={ <RightSideActions communication={communication} /> }
        >
        </Tile>
    )
}

const RightSideActions = ({communication}) => {
  return (
    <div style={{position:'absolute', right: '100px', padding: '6px'}}>
        <Button disabled={ false } qa-id="view-details">
          <Link onClick={()=>{  communication.read=true; communication.save();  }} href={ communication.createUrl() } style={{textDecoration: 'none', color:'#8FA9BD'}}>
            View Details
          </Link>
        </Button>
        <div onClick={() => { communication.destroy()}} className={'fa fa-trash '}
             style={{fontSize: '25px', color: '#8FA9BD', position:'fixed', paddingLeft: '10px'}}></div>
    </div>
  )
}

